import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { constants } from "../../config";
import { getAccessToken } from "../../utils/Functions";
import { IAuthenticationContext } from "../../auth/IAuthenticationContext";

export const getServicesThunk = createAsyncThunk(
  "services/getServices",
  async (authContext: IAuthenticationContext) => {
    let newToken = await getAccessToken(authContext);
    let payload = {
      email: authContext?.user?.email,
      services: process.env.REACT_APP_SERVICES?.split(","),
    };

    const { data } = await axios.post(
      constants.ROLE_MANAGER_API_BASE_URL + "/getServices",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Ocp-Apim-Subscription-Key":
            process.env.REACT_APP_APIM_SUBSCRIPTION_KEY,
          Authorization: `bearer ${newToken}`,
        },
      }
    );

    return data;
  }
);
